import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface ProgressItemProps {
  isActive: boolean;
}

export const ProgressBar = styled.div`
  max-width: 600px;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 4px;
  padding: 0px 16px;
`;

export const ProgressBarItem = styled.div<ProgressItemProps>`
  flex: 1;
  border-radius: 8px;
  background-color: ${(props: ProgressItemProps) =>
    props.isActive ? ColorPalette.HEX.OriolesOrange : ColorPalette.HEX.BrightGray7};
  margin: 0 2px;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media ${({ theme }) => theme.device.desktop} {
    margin-top: 40px;
  }
`;
